// removed by extract-text-webpack-plugin
module.exports = {"terms":"_1byDQdfeoaI4cI89wuqH_D"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Terms/Terms.scss
 ** module id = 748
 ** module chunks = 0
 **/